module.exports = __webpack_public_path__ + "img/comic-cover.2958e434.jpg";